import { jsx as _jsx } from "react/jsx-runtime";
export function Button({ variant = 'primary', style, ...rest }) {
    const baseStyle = {
        padding: '8px 16px',
        borderRadius: 8,
        border: 'none',
        fontWeight: 600,
        cursor: 'pointer',
        backgroundColor: variant === 'primary' ? '#4263eb' : '#e9ecef',
        color: variant === 'primary' ? 'white' : '#212529',
    };
    return _jsx("button", { style: { ...baseStyle, ...style }, ...rest });
}
//# sourceMappingURL=Button.js.map